import { Typography, Box } from "@mui/material";

const Settings = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Cài đặt hệ thống
      </Typography>
      <Typography variant="body1">Trang thay đổi cài đặt hệ thống.</Typography>
    </Box>
  );
};

export default Settings;
